import React from "react";
import {tileViewerPlotColors, zProfileFolderPath} from "../../../utils/const";
import {drawCircle, drawLine, getHighestFocusPoint, mapMotorToCanvas} from "../utils/map_utils";
import BaseLayer from "./BaseLayer";
import {Grid, Stack} from "@mui/material";
import {getPrefixedUrl, notNull} from "../../../utils/utils";
import {getFinalPlotData, getPlotPopup} from "./TileLayersUtils";

class FocusPointsLayer extends BaseLayer {

    id = "focusPoints";
    label = "Focus Points";
    defaultVisible = this.props.tileViewerState[this.id];

    onFeatureSelect = () => undefined;

    draw = () => new Promise((resolve, reject) => {
        let {
            multipleWSI3Focus,
            WSI3TestFocusUnits,
            multipleFocusData,
            failedFocus,
            focusOffset,
            focusDirPath,
            focusImgPath,
            tiltFocusPoints,
            focusProfile,
            textColor,
            textSize,
            countyTiltInfo,
            deviceSettings,
            focusPlots,
            slide,
            tileFlag
        } = this.props;
        let {y_fields, loc_on_machine, bucket_name, tile_height, uperpixel, tile_viewer_path} = slide;
        let xOffset = focusOffset['xy']["x_offset"];
        let yOffset = focusOffset['xy']["y_offset"];
        let highestPoint = getHighestFocusPoint(tiltFocusPoints, focusProfile, countyTiltInfo);
        if (focusProfile.length > 0 && !focusProfile[0]["counties"]) {
            for (let i = 0; i < focusProfile.length; i++) {
                let focusList = focusProfile[i]['focusList'];
                if (focusList) {
                    for (let j = 0; j < focusList.length; j++) {
                        if (focusList[j]['focusedAt'] !== null) {
                            let motorX = focusList[j]['focusedAt']['xPosition'];
                            let motorY = focusList[j]['focusedAt']['yPosition'];
                            let pos = mapMotorToCanvas(motorX, motorY, this.props.slide,
                                {device_settings: deviceSettings});
                            let x = pos.x;
                            let y = pos.y;
                            let zProfilePath1 = '';
                            let zProfilePath2 = '';
                            for (let l = 0; l < focusDirPath.focus_profile_dir_paths.length; l++) {
                                if (focusList[j]['idUp'] === focusDirPath.focus_profile_dir_paths[l][0]) {
                                    zProfilePath1 = focusDirPath.focus_profile_dir_paths[l];
                                } else if (focusList[j]['idDown'] === focusDirPath.focus_profile_dir_paths[l][0]) {
                                    zProfilePath2 = focusDirPath.focus_profile_dir_paths[l];
                                }
                            }
                            let link1 = "app://" + loc_on_machine + "/scans/" + bucket_name + "/" + tile_viewer_path +
                                zProfileFolderPath + zProfilePath1 + "/";
                            let link2 = "app://" + loc_on_machine + "/scans/" + bucket_name + "/" + tile_viewer_path +
                                zProfileFolderPath + zProfilePath2 + "/";
                            let popupText = (
                                <Stack>
                                    {"Focus ID UP " + focusList[j]['unifiedFocusId'] + "(" +
                                        focusList[j]['focusedUp'] + "), ID DOWN " + focusList[j]['unifiedFocusId'] +
                                        "(" + focusList[j]['focusedDown'] + ")"}
                                    <a href={link1}>{"ID " + focusList[j]['unifiedFocusId'] + " Location"}</a>
                                    <a href={link2}>{"ID " + focusList[j]['unifiedFocusId'] + " Location"}</a>
                                </Stack>
                            );
                            drawCircle(x, y, 0.3 * tile_height * uperpixel, this.layer.getSource(), "",
                                16, tileViewerPlotColors.doneFocusColor, popupText, textColor);
                        }
                    }
                }
            }
        } else {
            for (let i = 0; i < focusProfile.length; i++) {
                if (focusProfile[i]["islandKey"]["takeNumber"] !== 0)
                    continue;
                let countyData = focusProfile[i]["counties"];
                for (let idx = 0; idx < countyData.length; idx++) {
                    let focusList = countyData[idx]['focusList'];
                    let dualFocusList = countyData[idx]['dualFocusList'];
                    if (dualFocusList)
                        focusList = focusList.concat(dualFocusList);
                    if (focusList) {
                        for (let j = 0; j < focusList.length; j++) {
                            if (focusList[j]['focusedAt'] !== null) {
                                let motorX = focusList[j]['focusedAt']['xPosition'];
                                let motorY = focusList[j]['focusedAt']['yPosition'];
                                let zdiff;
                                Object.values(multipleFocusData).forEach((focusData) => {
                                    if ((motorX === focusData['motorX'] + xOffset && motorY === focusData['motorY'] + yOffset) ||
                                        (motorX === focusData['motorX'] && motorY === focusData['motorY'])) {
                                        for (let index = 0; index < focusData['uniqueFocusId'].length; index++) {
                                            let count = 0;
                                            for (const tiltInfo of countyTiltInfo) {
                                                const adjacentFU = tiltInfo['focusUnit'];
                                                const countyId = tiltInfo['county']['countykey']['countyId'];
                                                // const cKey = adjacentFU['countyKeyForFocusPoint'][0]['countyId'];
                                                // console.log("__county", adjacentFU['unifiedFocusId'], countyId, cKey);
                                                if (adjacentFU?.['unifiedFocusId'] === focusData['uniqueFocusId'][index]
                                                    && countyId === focusData['county'][index])
                                                    count += 1;
                                            }
                                            if (count === 0) {
                                                let radius = index * 0.5 * tile_height * uperpixel;
                                                let motorX = focusData['motorX'];
                                                let motorY = focusData['motorY'];
                                                let {x, y} = mapMotorToCanvas(motorX, motorY, this.props.slide,
                                                    {device_settings: deviceSettings});
                                                if (tileFlag['reverseYTileOrder']['flagY'])
                                                    y = slide.y_fields * (tile_height * uperpixel) - y;
                                                let zProfilePath = '';
                                                for (let l = 0; l < focusDirPath.focus_profile_dir_paths.length; l++) {
                                                    const path = focusDirPath.focus_profile_dir_paths[l].split("_");
                                                    const lastElement = path.pop();
                                                    if (focusData['uniqueFocusId'][index] === parseInt(lastElement)) {
                                                        zProfilePath = focusDirPath.focus_profile_dir_paths[l];
                                                    }
                                                }
                                                Object.values(focusPlots).forEach(val => {
                                                    if (focusData['uniqueFocusId'][index] === parseInt(val['index']) && highestPoint) {
                                                        let finalPlotData = getFinalPlotData(val);
                                                        let popup = getPlotPopup(zProfilePath, finalPlotData, val['index']);
                                                        zdiff = focusData['focusedDown'][index] - highestPoint;
                                                        zdiff = Math.round((zdiff + Number.EPSILON) * 100) / 100;
                                                        let sign = index % 2 ? -1 : 1;
                                                        drawLine(x, y + (sign) * (0.6 * tile_height * uperpixel + radius * (index +1)), 1, this.layer.getSource(),
                                                            zdiff, 10, "#E9D6C5", popup, textColor, textSize);
                                                    }
                                                });
                                                let link2 = "app://" + loc_on_machine + "/scans/" + bucket_name + "/" + tile_viewer_path +
                                                    zProfileFolderPath + zProfilePath + "/";
                                                let link1 = '', isFine = '';
                                                Object.values(focusImgPath).forEach(val => {
                                                    if (focusData['uniqueFocusId'][index] === parseInt(val['index'])) {
                                                        link1 = getPrefixedUrl(`debug/zprofile/${val["img"]}`, this.props.slide, true);
                                                        isFine = val["isFineLocated"];
                                                    }
                                                });
                                                let popupText = (
                                                    <Stack>
                                                        {"Focus ID DOWN " + focusData['uniqueFocusId'][index] + "(" +
                                                            focusData['focusedDown'][index] + ")"}
                                                        {" CountyId: " + focusData['county'][index]}
                                                        <Grid>
                                                            <a href={link2}>{"ID " + focusData['uniqueFocusId'][index] + " Location "}</a>
                                                            <a href={link1}
                                                               target={"_blank"}>{isFine ? " [Fine Locator Img]"
                                                                : "[Best Focussed Img]"}</a>
                                                        </Grid>
                                                        <Grid>{"The displayed value is Δz i.e. " + zdiff}</Grid>
                                                        <Grid>{"Click on Δz Value to open the focus plot"}</Grid>
                                                    </Stack>
                                                );
                                                drawCircle(x, y, 0.6 * tile_height * uperpixel - radius, this.layer.getSource(), "",
                                                    16, "#f4c2c2", popupText, textColor);
                                            }
                                        }
                                    }
                                });
                            }
                        }
                    }
                }
            }
            // failed focus points
            notNull(failedFocus) && Object.values(failedFocus).forEach(val => {
                let motorX = parseInt(val['motorPosX']);
                let motorY = parseInt(val['motorPosY']);
                let {x, y} = mapMotorToCanvas(motorX, motorY, this.props.slide,
                    {device_settings: deviceSettings});
                if (tileFlag['reverseYTileOrder']['flagY'])
                    y = slide.y_fields * (tile_height * uperpixel) - y;
                let zProfilePath = '';
                for (let l = 0; l < focusDirPath.focus_profile_dir_paths.length; l++) {
                    const focus_profile_path = focusDirPath.focus_profile_dir_paths[l]
                    if (val['path'] === focus_profile_path) {
                        zProfilePath = focus_profile_path;
                    }
                }
                Object.entries(focusPlots).forEach(([key,val]) => {
                    if (zProfilePath === key && highestPoint) {
                        let finalPlotData = getFinalPlotData(val);
                        let popup = getPlotPopup(zProfilePath, finalPlotData, val['index']);
                        drawLine(x, y, 1, this.layer.getSource(),
                            "Focus Failed", 10, "#E9D6C5", popup, textColor, textSize);
                    }
                });
                drawCircle(x, y, 0.3 * tile_height * uperpixel, this.layer.getSource(), "",
                    16, "rgb(173,161,161)", "Focus Failed", textColor);
            });
            // county adjacent FU
            for (const tiltInfo of countyTiltInfo) {
                const adjacentFU = tiltInfo['focusUnit'];
                const countyId = tiltInfo['county']['countykey']['countyId'];
                if (adjacentFU === null || adjacentFU === undefined)
                    continue;

                let motorPos = adjacentFU['focusedAt'];
                let hasMotorPos = (motorPos !== null && motorPos !== undefined);
                let motorX = motorPos['xPosition'] - xOffset;
                let motorY = motorPos['yPosition'] - yOffset;
                let {x, y} = mapMotorToCanvas(motorX, motorY, this.props.slide,
                    {device_settings: deviceSettings});
                if (tileFlag['reverseYTileOrder']['flagY'])
                    y = y_fields * (tile_height * uperpixel) - y;
                if (adjacentFU['tiledFocusedAt'] === null) {
                    adjacentFU['tiledFocusedAt'] = {'first': "unknown", 'second': "unknown"};
                }
                let zProfilePath = '', zdiff;
                for (let l = 0; l < focusDirPath.focus_profile_dir_paths.length; l++) {
                    const path = focusDirPath.focus_profile_dir_paths[l].split("_");
                    const lastElement = path.pop();
                    if (adjacentFU['unifiedFocusId'] === parseInt(lastElement)) {
                        zProfilePath = focusDirPath.focus_profile_dir_paths[l];
                    }
                }
                Object.values(focusPlots).forEach(val => {
                    if (adjacentFU['unifiedFocusId'] === parseInt(val['index']) && highestPoint) {
                        let finalPlotData = getFinalPlotData(val);
                        let popup = getPlotPopup(zProfilePath, finalPlotData, val['index']);
                        zdiff = adjacentFU['focusedDown'] - highestPoint;
                        zdiff = Math.round((zdiff + Number.EPSILON) * 100) / 100;
                        drawLine(x, y - 0.75 * tile_height * uperpixel, 1, this.layer.getSource(),
                            zdiff, 10, "#f4c2c2", popup, textColor, textSize);
                    }
                });
                let link1 = "app://" + loc_on_machine + "/scans/" + bucket_name + "/" + tile_viewer_path + zProfileFolderPath
                    + zProfilePath;
                let link2 = '', isFine = '';
                Object.values(focusImgPath).forEach(val => {
                    if (adjacentFU['unifiedFocusId'] === parseInt(val['index'])) {
                        link2 = getPrefixedUrl(`debug/zprofile/${val["img"]}`, this.props.slide, true);
                        isFine = val["isFineLocated"];
                    }
                });

                if (hasMotorPos) {
                    let {x, y} = mapMotorToCanvas(motorX, motorY, this.props.slide, {device_settings: deviceSettings});
                    if (tileFlag['reverseYTileOrder']['flagY'])
                        y = y_fields * (tile_height * uperpixel) - y;
                    let popupText2 = (
                        <Stack>
                            <Grid>{"Focus ID DOWN " + adjacentFU['unifiedFocusId'] +
                                "(" + adjacentFU['focusedDown'] + ")"}
                                {" CountyId: " + countyId}
                            </Grid>
                            <Grid>
                                <a href={link1}>{"ID " + adjacentFU['unifiedFocusId'] + " Location"}</a>
                                <a href={link2} target={"_blank"}>{isFine ? " [Fine Locator Img]"
                                    : "[Best Focussed Img]"}</a>
                            </Grid>
                            <Grid>{"The displayed value is Δz i.e. " + zdiff}</Grid>
                            <Grid>{"Click on Δz Value to open the focus plot"}</Grid>
                        </Stack>
                    );
                    drawCircle(x, y, 0.75 * tile_height * uperpixel, this.layer.getSource(), "", 7,
                        "#AAFF00", popupText2, textColor);
                }
            }
        }
        // WSI3 Test Focus Units
        if (WSI3TestFocusUnits !== undefined && multipleWSI3Focus !== undefined) {
            Object.values(WSI3TestFocusUnits).forEach(val => {
                let motorX, motorY, zdiff;
                if (val['finePositionsToTry']) {
                    motorX = val['finePositionsToTry'][0]['xPosition'] - xOffset;
                    motorY = val['finePositionsToTry'][0]['yPosition'] - yOffset;
                } else {
                    motorX = val['focusedAt']['xPosition'] - xOffset;
                    motorY = val['focusedAt']['yPosition'] - yOffset;
                }
                let {x, y} = mapMotorToCanvas(motorX, motorY, this.props.slide,
                    {device_settings: deviceSettings});
                if (tileFlag['reverseYTileOrder']['flagY'])
                    y = slide.y_fields * (tile_height * uperpixel) - y;
                Object.values(multipleWSI3Focus).forEach(wsi3Data => {
                    if (motorX === wsi3Data['motorX'] && motorY === wsi3Data['motorY']) {
                        for (let index = 0; index < wsi3Data['uniqueFocusId'].length; index++) {
                            let radius = index * 0.05 * tile_height * uperpixel;
                            let zProfilePath = '';
                            for (let l = 0; l < focusDirPath.focus_profile_dir_paths.length; l++) {
                                const path = focusDirPath.focus_profile_dir_paths[l].split("_");
                                const lastElement = path.pop();
                                if (wsi3Data['uniqueFocusId'][index] === parseInt(lastElement)) {
                                    zProfilePath = focusDirPath.focus_profile_dir_paths[l];
                                }
                            }
                            Object.values(focusPlots).forEach(val => {
                                if (wsi3Data['uniqueFocusId'][index] === parseInt(val['index']) && highestPoint) {
                                    let finalPlotData = getFinalPlotData(val);
                                    let popup = getPlotPopup(zProfilePath, finalPlotData, val['index']);
                                    zdiff = wsi3Data['focusedDown'][index] - highestPoint;
                                    zdiff = Math.round((zdiff + Number.EPSILON) * 100) / 100;
                                    drawLine(x, y + 0.35 * tile_height * uperpixel + radius, 1, this.layer.getSource(),
                                        "Δz " + zdiff, 10, "#E9D6C5", popup, textColor, textSize);
                                }
                            });
                            let link2 = "app://" + loc_on_machine + "/scans/" + bucket_name + "/" + tile_viewer_path +
                                zProfileFolderPath + zProfilePath + "/";
                            let link1 = '', isFine = '';
                            Object.values(focusImgPath).forEach(val => {
                                if (wsi3Data['uniqueFocusId'][index] === parseInt(val['index'])) {
                                    link1 = getPrefixedUrl(`debug/zprofile/${val["img"]}`, this.props.slide, true);
                                    isFine = val["isFineLocated"];
                                }
                            });
                            let popupText = (
                                <Stack>
                                    {"Focus ID DOWN " + wsi3Data['uniqueFocusId'][index] + "(" + wsi3Data['focusedDown'][index] + ")"}
                                    {" CountyId: " + wsi3Data['county'][index]}
                                    <Grid>
                                        <a href={link2}>{"ID " + wsi3Data['uniqueFocusId'][index] + " Location "}</a>
                                        <a href={link1} target={"_blank"}>{isFine ? " [Fine Locator Img]"
                                            : "[Best Focussed Img]"}</a>
                                    </Grid>
                                    <Grid>{"The displayed value is Δz i.e. " + zdiff}</Grid>
                                    <Grid>{"Click on Δz Value to open the focus plot"}</Grid>
                                </Stack>
                            );
                            drawCircle(x, y, 0.35 * tile_height * uperpixel + radius, this.layer.getSource(), "",
                                12, "#c00e0e", popupText, textColor);
                        }
                    }
                });
            });
        }
        resolve();
    });
}

export default FocusPointsLayer;